// extracted by mini-css-extract-plugin
export default {"DropZoneContainer":"DropzoneAdditionalVideo_DropZoneContainer__E60B6","Center":"DropzoneAdditionalVideo_Center__BiwcF","error":"DropzoneAdditionalVideo_error__Y6ifQ"};